import React from 'react';
import { Link } from 'react-router-dom';
import { allCaseStudies } from '../data/caseStudyData';

const CaseStudyListPage: React.FC = () => (
    <div className="pt-20 bg-gray-50 min-h-screen">
        <header className="bg-white py-16 text-center border-b">
            <div className="container mx-auto px-6">
                <h2 className="text-5xl font-extrabold text-[#3aabd2] mb-2" style={{ fontFamily: "'Inter', sans-serif" }}>Case Study</h2>
                <p className="text-lg text-[#4b5563]" style={{ fontFamily: "'Inter', sans-serif" }}>事例紹介</p>
            </div>
        </header>
        <section className="py-20">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[...allCaseStudies].sort((a, b) => b.id - a.id).map(item => (
                        <Link key={item.id} to={item.link} className="block bg-white rounded-lg shadow-md overflow-hidden group border border-gray-200 hover:shadow-xl hover:border-[#3aabd2] transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                            <div className="aspect-video bg-white flex items-center justify-center p-0 overflow-hidden">
                                <img src={item.logo} alt={item.companyName} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                            </div>
                            <div className="border-t border-gray-100"></div>
                            <div className="p-6 flex-grow flex flex-col">
                                <div className="mb-2">
                                    <span className="inline-block px-2 py-0.5 border border-[#3aabd2] text-[#3aabd2] text-[10px] font-medium rounded">
                                        {item.category}
                                    </span>
                                </div>
                                <h3 className="text-lg font-bold text-gray-800 group-hover:text-[#3aabd2] transition-colors duration-300 mb-2">{item.companyName}</h3>
                                {/* ▼▼▼ 修正箇所：dangerouslySetInnerHTML を追加 ▼▼▼ */}
                                <p className="text-gray-600 text-sm line-clamp-3 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.summary }}></p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    </div>
);

export default CaseStudyListPage;